module.exports = __webpack_public_path__ + "img/80.a9d0d1c1.jpg";